<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      ГОСТ 5686-2012<br>
      Приложение Ж<br>
      (рекомендуемое)
    </div>
    <div class="chapter-title">Журнал <br>полевого испытания грунтов статическими вдавливающими, выдергивающими и горизонтальными нагрузками</div>
    <n-items v-if="project">
      <n-input title="Организация" v-bind="$form.input('p1.1')" :text="!editable" />
      <n-input title="Пункт" v-bind="$form.input('p1.2')" :text="!editable" />
      <n-input title="Объект " v-bind="$form.input('p1.3')" :text="!editable" />
      <n-input title="Сооружение " v-bind="$form.input('p1.4')" :text="!editable" />
    </n-items>
    <div class="chapter-title">Журнал <br>полевого испытания грунтов статическими вдавливающими, выдергивающими и горизонтальными нагрузками</div>
    <n-items v-if="project">
      <n-input title="Дата испытания: начало" v-bind="$form.input('p1.5')" :text="!editable" />
      <n-input title="Дата испытания: окончание" v-bind="$form.input('p1.6')" :text="!editable" />
      <n-input title="Свая №" v-bind="$form.input('p1.7')" :text="!editable" />
      <n-input title="Дата погружения сваи" v-bind="$form.input('p1.8')" :text="!editable" />
      <n-input title="Вид сваи" v-bind="$form.input('p1.9')" :text="!editable" />
      <n-input title="Способ погружения или устройства" v-bind="$form.input('p1.10')" :text="!editable" />
      <n-input title="Материал сваи" v-bind="$form.input('p1.11')" :text="!editable" />
      <n-input title="Оборудование, применявшееся при погружении или устройстве сваи" v-bind="$form.input('p1.12')" :text="!editable" />
      <n-input title="Дата изготовления сваи" v-bind="$form.input('p1.13')" :text="!editable" />
      <n-input title="Сечение (диаметр) сваи на верхнем и нижнем концах" v-bind="$form.input('p1.14')" :text="!editable" />
      <n-input title="Абсолютные отметки: -головы сваи после погружения" v-bind="$form.input('p1.15')" :text="!editable" />
      <n-input title="Абсолютные отметки: -головы сваи перед испытанием" v-bind="$form.input('p1.16')" :text="!editable" />
      <n-input title="Абсолютные отметки: -нижнего конца" v-bind="$form.input('p1.17')" :text="!editable" />
      <n-input title="Абсолютные отметки: -поверхности грунта у сваи" v-bind="$form.input('p1.18')" :text="!editable" />
      <n-input title="Длинна сваи (без острия)" v-bind="$form.input('p1.19')" :text="!editable" />
      <n-input title="Длинна острия" v-bind="$form.input('p1.20')" :text="!editable" />
      <n-input title="Масса сваи" v-bind="$form.input('p1.21')" :text="!editable" />
      <n-input title="Ближайшая геологическая выработка №" v-bind="$form.input('p1.22')" :text="!editable" />
      <n-input title="Состояние головы сваи после погружения (забивки)" v-bind="$form.input('p1.23')" :text="!editable" />
      <n-input title="Пройдено" v-bind="$form.input('p1.24')" :text="!editable" />
      <n-input title="Глубина погружения (заложения) сваи" v-bind="$form.input('p1.25')" :text="!editable" />
      <n-input title="Расстояние выработки от сваи" v-bind="$form.input('p1.26')" :text="!editable" />
      <n-input title="Тип приборов для измерения перемещений сваи" v-bind="$form.input('p1.27')" :text="!editable" />
      <n-input title="Краткая характеристика инженерно-геологического разреза в месте расположения сваи" v-bind="$form.input('p1.28')" :text="!editable" />
      <n-input title="Температура воздуха" v-bind="$form.input('p1.29')" :text="!editable" />
      <n-input title="Температура воды (при испытаниях на акватории)" v-bind="$form.input('p1.30')" :text="!editable" />
      <div>Примечание. На первой странице журнала приводят схему фактической испытательной установки и расположения приборов для измерения перемещений сваи, а также расположения ближайших инженерно-геологических выработок и точек зондирования.</div>
      <n-input title="Наименование объекта" v-bind="$form.input('p1.31')" :text="!editable" />
      <n-input title="Испытание №" v-bind="$form.input('p1.32')" :text="!editable" />
      <n-input title="Страница №" v-bind="$form.input('p1.33')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
